import { Localization } from "../../../common/localizable-component";
import { DateLocalization } from "./date-event-types";
import { deepmerge } from "../../../utils/deep-merge";
import { FORM_LOCALIZATION } from "../../form/constants/form-i18n";

export const DATE_LOCALIZATION: Localization<DateLocalization> = deepmerge(FORM_LOCALIZATION, {
  en: {
    locale: "en-US"
  },
  es: {
    locale: "es-ES"
  },
  de: {
    locale: "de-DE"
  },
  cs: {
    locale: "cs-CZ"
  },
  fr: {
    locale: "fr-FR"
  },
  hr: {
    locale: "hr-HR"
  },
  hu: {
    locale: "hu-HU"
  },
  it: {
    locale: "it-IT"
  },
  pl: {
    locale: "pl-PL"
  },
  ro: {
    locale: "ro-RO"
  },
  sk: {
    locale: "sk-SK"
  },
  sl: {
    locale: "sl-SL"
  },
  sr: {
    locale: "sr-SR"
  },
  sv: {
    locale: "sv-SE"
  },
  tr: {
    locale: "tr-TR"
  },
  no: {
    locale: "no-NO"
  },
  ru: {
    locale: "ru-RU"
  },
  nl: {
    locale: "nl-NL"
  },
  da: {
    locale: "da-DK"
  }
});
